import { EvChargingStationMap } from '@/components/feature/EvChargingStationPage'
import { Container } from './styles'

function EvChargingStation() {
  return (
    <Container>
      <EvChargingStationMap />
    </Container>
  )
}

export default EvChargingStation
